export const validatePassword = password => {
  const validation = {
    ok: false,
    error: true,
    errors: {
      empty: true
    }
  };

  if (!password && password.length <= 0) {
    return validation;
  }

  validation.ok = true;
  validation.error = false;
  validation.errors.empty = false;
  
  validation.errors.uppercase = !password.match(/[A-Z]/);
  validation.errors.lowercase = !password.match(/[a-z]/);
  validation.errors.digit = !password.match(/\d/);
  validation.errors.minSize = !password.match(/\S{8,}/);

  Object.keys(validation.errors).forEach(errorKey => {
    if (validation.errors[errorKey]) {
      validation.ok = false;
      validation.error = true;
    }
  });

  return validation;
};